'use es6';

import { forkJoin } from 'rxjs/observable/forkJoin';
import http from 'hub-http-rxjs/clients/apiClient';
const URI = 'contentmembership/public-access/lists-registrations';
export default class ListRegistrationsAPI {
  static fetchListRegistration(listId) {
    return http.get(URI, {
      query: {
        listId
      }
    });
  }

  static fetchListRegistrations(listIds) {
    return forkJoin([...listIds.map(id => this.fetchListRegistration(id))]);
  }

}